var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    {
      staticClass: "login-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      !_vm.formState.processing && _vm.formState.message.length > 0
        ? _c("b-alert", { attrs: { variant: _vm.formAlertType, show: "" } }, [
            _vm._v("\n        " + _vm._s(_vm.formState.message) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Login or Email address" } },
        [
          _c("b-form-input", {
            attrs: { type: "text", state: _vm.loginValid },
            model: {
              value: _vm.formData.login,
              callback: function ($$v) {
                _vm.$set(
                  _vm.formData,
                  "login",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "formData.login",
            },
          }),
          _vm._v(" "),
          _c("b-form-invalid-feedback", { attrs: { state: _vm.loginValid } }, [
            _vm._v(
              "\n            " + _vm._s(_vm.formValidation.login) + "\n        "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Password" } },
        [
          _c("b-form-input", {
            attrs: { type: "password", state: _vm.passwordValid },
            model: {
              value: _vm.formData.password,
              callback: function ($$v) {
                _vm.$set(
                  _vm.formData,
                  "password",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "formData.password",
            },
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.passwordValid } },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.formValidation.password) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "login-submit",
          attrs: {
            type: "submit",
            variant: "primary",
            block: "",
            disabled: _vm.formState.processing,
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(!_vm.formState.processing ? "Login" : "Processing...") +
              "\n    "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }